import type { Recipe } from '../../build-config';
import { isSelect, onPlans } from '../helpers/elevations';
import { roofLayer, sidingLayer } from '../helpers/layers';

export const planSelectRecipe = (plans: string[], state?: Recipe['state']): Recipe => ({
  layers: [roofLayer, sidingLayer],
  where: (elevation) => isSelect(elevation) && onPlans(plans)(elevation),
  state
});
